import { render, staticRenderFns } from "./PublishOptionsDialog.vue?vue&type=template&id=08492a42&scoped=true"
import script from "./PublishOptionsDialog.vue?vue&type=script&lang=js"
export * from "./PublishOptionsDialog.vue?vue&type=script&lang=js"
import style0 from "./PublishOptionsDialog.vue?vue&type=style&index=0&id=08492a42&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08492a42",
  null
  
)

export default component.exports